"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ defaults, palette, spacing, components, mixins }) => ({
    header: {
        minHeight: defaults.headers.headerHeight,
        borderBottom: `1px solid ${palette.border.dark}`,
        backgroundColor: palette.background.paper,
        zIndex: 2,
    },
    paperContainer: {
        marginBottom: spacing(3),
        padding: spacing(2),
        minHeight: 500,
        overflowY: 'auto',
    },
    textEllipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    headerControls: {
        textTransform: 'none',
        fontSize: 16,
    },
    datasetSwitchingContent: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    datasetSwitchingProgress: {
        marginTop: 30,
    },
    disableSection: {
        pointerEvents: 'none',
    },
    alert: {
        background: palette.background.hint,
        color: palette.text.strong,
        fontSize: 16,
        padding: '2px 8px',
        display: 'flex',
        alignItems: 'center',
    },
    sharedTableAlert: {
        padding: '2px 8px',
        margin: '0 8px 8px 8px',
    },
    sharedUserChip: {
        height: 28,
        borderRadius: 14,
        backgroundColor: palette.action.selected,
        borderColor: palette.action.selected,
        textTransform: 'capitalize',
        maxWidth: 250,
        color: palette.text.primary,
        '& .MuiChip-label': {
            padding: '0 12px',
            textAlign: 'center',
            fontSize: 12,
            color: palette.text.primary,
        },
        '& .MuiTypography-root': {
            color: palette.text.primary,
            fontSize: 12,
        },
        '&.MuiChip-outlined': {
            backgroundColor: palette.action.selected,
            borderColor: palette.action.selected,
        },
    },
    sharedUserChipOverflow: {
        backgroundColor: palette.background.elevated,
        borderColor: palette.background.elevated,
        '&.MuiChip-outlined': {
            backgroundColor: palette.background.elevated,
            borderColor: palette.background.elevated,
        },
    },
    anchorStyle: {
        color: `${mixins.navigation.headerColor} !important`,
        textDecoration: 'none',
    },
});
exports.default = styles;
